<!--<c-footer>-->
<div>
  <span> &copy; {{ date }} Cartelys</span>
</div>

<!--</c-footer>-->